import { render, staticRenderFns } from "./SearchKeywordMgmt.vue?vue&type=template&id=8a867ebe"
import script from "./SearchKeywordMgmt.vue?vue&type=script&lang=js"
export * from "./SearchKeywordMgmt.vue?vue&type=script&lang=js"
import style0 from "./SearchKeywordMgmt.vue?vue&type=style&index=0&id=8a867ebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports